export default __webpack_public_path__ + "static/media/image-world-class-talent.a112497a.jpg";